import React, { useEffect, useContext, useState, useRef } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom';

import Moment from 'moment'

import LanguageContext from "../../../contexts/LanguageContext"

import { Box, Hidden, CircularProgress, Button } from '@material-ui/core'

import noCompletionChartIcon from "../../../images/noCompletionChartIcon.svg"

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line, getDatasetAtEvent } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

let actFocusIndex = null
function scale(number, inMin, inMax, outMin, outMax) {
  return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
}
function getGradient(ctx, chartArea, dataset, chart) {
  let topValue = scale(dataset.data[dataset.data.length - 1], chart.scales['y'].min, chart.scales['y'].max, chartArea.bottom, chartArea.top)
  let rgbColor = hexToRgb(dataset.borderColor)
  //let calcAngle = (chartArea.right - chartArea.left) / 2
  //console.log(calcAngle)
  let gradient = ctx.createLinearGradient(
    0,
    chartArea.bottom,
    0,
    //chartArea.top
    topValue
  );
  gradient.addColorStop(1, "rgba("+rgbColor.r+","+rgbColor.g+","+rgbColor.b+",0.5)");
  gradient.addColorStop(0, "rgba(255,255,255,0)");
  return gradient;
}
const options = {
  responsive: true,
  maintainAspectRatio: false,
  onClick: (e, activeEls) => {
    if (activeEls[0]) {
      let datasetIndex = activeEls[0].datasetIndex;
      if (actFocusIndex !== datasetIndex) {
        if (actFocusIndex !== null) {
          e.chart.data.datasets[actFocusIndex].backgroundColor = "transparent"
        }
        e.chart.data.datasets[datasetIndex].backgroundColor = getGradient(e.chart.ctx, e.chart.chartArea, e.chart.data.datasets[datasetIndex], e.chart);
        actFocusIndex = datasetIndex
        e.chart.update()
      }
    } else {
      if (actFocusIndex !== null) {
        e.chart.data.datasets[actFocusIndex].backgroundColor = "transparent"
        actFocusIndex = null
        e.chart.update()
      }
    }
  },
  onHover: (e, activeEls) => {
    if (activeEls[0]) {
      let datasetIndex = activeEls[0].datasetIndex;
      if (actFocusIndex !== datasetIndex) {
        if (actFocusIndex !== null) {
          e.chart.data.datasets[actFocusIndex].backgroundColor = "transparent"
        }
        e.chart.data.datasets[datasetIndex].backgroundColor = getGradient(e.chart.ctx, e.chart.chartArea, e.chart.data.datasets[datasetIndex], e.chart);
        actFocusIndex = datasetIndex
        e.chart.update()
      }
    } else {
      if (actFocusIndex !== null) {
        e.chart.data.datasets[actFocusIndex].backgroundColor = "transparent"
        actFocusIndex = null
        e.chart.update()
      }
    }
  },
  plugins: {
    legend: {
      display:false
    },
    title: {
      display: true,
      align : "start",
      position:"top",
      color : "#000000",
      padding : {
        bottom : 25,
        top : 0,
      },
      font : {
        family : "Questrial",
        weight:400,
        size: 23,
      },
    },
    tooltip : {
      backgroundColor:"white",
      titleColor:"rgba(0, 0, 0, 0.6)",
      titleFont : {
        family : "Questrial",
        weight:400,
      },
      bodyColor:"black",
      bodyFont : {
        family : "Questrial",
        weight:400,
      },
      boxPadding : 3,
      animation: false,
      borderWidth: 1,
      borderColor:"rgba(0, 0, 0, 1)",
      cornerRadius:0,
      caretSize:0,
      caretPadding:10,
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      border : {
        width : 0,
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        font: {
          family : "Questrial",
          weight:400,
        },
      }
    },
    y: {
      min:0,
      suggestedMax:10,
      border : {
        width : 0,
      },
      grid: {
        display: true,
        color : "rgba(199, 211, 222, 0.25)",
      },
      ticks: {
        color: "rgba(0, 0, 0, 0.6)",
        font: {
          family : "Questrial",
          weight:400,
        },
      }
    }
  }
};



Moment.locale('fr')

const CompletionChart = (props, context) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  const chartRef = useRef();

  const [data, setData] = useState({})

  const [loadChart, setLoadChart] = useState(false)

  let colors=[
    '#0C457C',
    '#F290FF', '#764BA2', '#FB5607', '#1DD3B0', '#FF4D6D', '#AF4319',
    '#F290FF', '#764BA2', '#FB5607', '#1DD3B0', '#FF4D6D', '#AF4319',
    '#F290FF', '#764BA2', '#FB5607', '#1DD3B0', '#FF4D6D', '#AF4319',
  ]


  useEffect(() => {
    if (props.completion.length > 0) {
      let datesArr = getDates()
      //console.log(datesArr)


      let dataArr = []
      if (props?.subGroup?.icebreaker) { //pour l'icebreaker
        let icebreakerPlan = {
          openDate : '2023-01-01',
          closeDate : '2999-01-01',
          name : 'ICEBREAKER',
          id : props?.subGroup?.icebreaker,
          surname : '#ICEBREAKER',
          color : '#ef9d10',
        }
        let filterCompletion = props.completion.filter((el) => parseInt(el.contentID) === parseInt(icebreakerPlan?.id))
        let completionData = []
        datesArr.forEach((date) => {
          let filterByDate = filterCompletion.filter((el) => {
            return Moment(el.updatedAt).isSameOrBefore(date, 'days')
          })
          completionData.push(filterByDate.length)
        })

        let color = "#94f7ff"
        dataArr.push({
          label : icebreakerPlan?.name,
          borderColor: color,
          fill: true,
          pointBackgroundColor:color,
          pointHoverBackgroundColor:color,
          backgroundColor: "transparent",
          cubicInterpolationMode: 'monotone',
          data: completionData,
          pointRadius : completionData.map((x, index) => index === (completionData.length-1) ? 3 : 0),
          hitRadius : 10,
        })
      }

      props?.plan?.forEach((p, index) => {
        let filterCompletion = props.completion.filter((el) => parseInt(el.contentID) === parseInt(p.id))
        let completionData = []
        datesArr.forEach((date) => {
          let filterByDate = filterCompletion.filter((el) => {
            return Moment(el.updatedAt).isSameOrBefore(date, 'days')
          })
          completionData.push(filterByDate.length)
        })

        let color = props?.plan?.length > 1 ? colors[index+1] : colors[index]

        dataArr.push({
          label : p.name,
          borderColor: color,
          fill: true,
          pointBackgroundColor:color,
          pointHoverBackgroundColor:color,
          backgroundColor: "transparent",
          cubicInterpolationMode: 'monotone',
          data: completionData,
          pointRadius : completionData.map((x, index) => index === (completionData.length-1) ? 3 : 0),
          hitRadius : 10,
        })
      })

      //on ajoute le total si besoin
      if (dataArr.length > 1) {

        let completionData = []
        datesArr.forEach((date) => {
          let filterByDate = props.completion.filter((el) => {
            return Moment(el.updatedAt).isSameOrBefore(date, 'days')
          })

          let resultByUser = []
          filterByDate.forEach((result) => {
            let find = resultByUser.find((el) => el.userID === result.userID)
            if (find) {
              find.resultIDs.push(result.id)
            } else {
              resultByUser.push({
                userID : result.userID,
                resultIDs : [result.id]
              })
            }
          })
          let lengthToTest = props?.plan?.length
          if (props?.subGroup?.icebreaker) {
            lengthToTest+=1
          }
          let nbr = resultByUser.filter((el) => el.resultIDs.length === lengthToTest).length
          completionData.push(nbr)

        })

        dataArr.push({
          label : languageValues?.adminDashboard?.completionChart?.average[actLanguage],
          borderColor: colors[0],
          fill: true,
          pointBackgroundColor:colors[0],
          pointHoverBackgroundColor:colors[0],
          backgroundColor: "transparent",
          cubicInterpolationMode: 'monotone',
          data: completionData,
          pointRadius : completionData.map((x, index) => index === (completionData.length-1) ? 3 : 0),
          hitRadius : 10,
        })
      }

      let newData = {
        labels : datesArr.map((x) => Moment(x).format('DD/MM/YYYY')),
        datasets: dataArr,
      }

      setData(newData)
    }
  }, [props])

  const getDates = () => {
    //let today = Moment("13/02/2023", "DD/MM/YYYY") //for test

    let planDates = []
    props.plan?.forEach((p) => {
      planDates.push(Moment(p.openDate, "YYYY-MM-DD"))
      planDates.push(Moment(p.closeDate, "YYYY-MM-DD"))
    })
    planDates = planDates.sort((a, b) => a.valueOf() - b.valueOf())

    if (planDates?.length > 0) {
      let firstDate = planDates[0]
      let lastDate = planDates[planDates.length - 1]
      let diffInDays = lastDate.diff(firstDate, 'days', true);
      let diffInWeeks = lastDate.diff(firstDate, 'weeks', true);
      let diffInMonths = lastDate.diff(firstDate, 'months', true);
      /*console.log(diffInDays+ " days for plan")
      console.log(diffInWeeks+ "weeks for plan")
      console.log(diffInMonths+ "months for plan")*/

      let dates=[]
      dates.push(firstDate)

      if (diffInDays <= 7) {
        for (let i=0; i<diffInDays-1; i++) {
          dates.push(Moment(firstDate).add(i+1, 'days'))
        }
      } else if (diffInDays <= 14) {
        for (let i=0; i<diffInDays-1; i++) {
          if (i%2 === 1) {
            dates.push(Moment(firstDate).add(i+1, 'days'))
          }
        }
      } else if (diffInDays <= 28) {
        for (let i=0; i<diffInDays-1; i++) {
          if (i%3 === 0 && i !== 0) {
            dates.push(Moment(firstDate).add(i, 'days'))
          }
        }
      } else {
        if (diffInWeeks > 52) { //plus d'un 1
          for (let i=0; i<diffInDays-1; i++) { //1 date par mois
            if (i%30 === 0 && i !== 0) {
              dates.push(Moment(firstDate).add(i, 'days'))
            }
          }
        } else { //2 date par mois
          for (let i=0; i<diffInDays-1; i++) {
            if (i%15 === 0 && i !== 0) {
              dates.push(Moment(firstDate).add(i, 'days'))
            }
          }
        }
      }

      dates.push(lastDate)

      let finalDates = []
      if (firstDate.isAfter(Moment())) {
        //console.log("on est avant le début du plan")
        setLoadChart(false)
      } else if (lastDate.isSameOrBefore(Moment())) {
        //console.log("on est après la fin du plan")
        finalDates = dates
        setLoadChart(true)
      } else {
        //console.log("on est pendant le plan")
        dates.forEach((date) => {
          if (date.isSameOrBefore(Moment())) {
            finalDates.push(date)
          }
        })
        let haveToAddTodayDate = true
        finalDates.forEach((date) => {
          if (date.isSame(Moment(), 'day') === true) {
            haveToAddTodayDate = false
          }
        })
        if (haveToAddTodayDate === true) {
          finalDates.push(Moment())
        }
        setLoadChart(true)
      }

      return finalDates
    } else {
      return []
    }


  }

  options.plugins.title.text = languageValues?.adminDashboard?.completionChart?.title[actLanguage]

  var chartpluginsset = [
    {
      afterEvent :(chart, args, pluginOptions) => {
        const event = args.event;
        if (event.type === 'mouseout') {
          if (actFocusIndex !== null) {
            chart.data.datasets[actFocusIndex].backgroundColor = "transparent"
            actFocusIndex = null
            chart.update()
          }
        }
      },
    }
  ];

  return (
    <>
      {loadChart === true && props.dataLoaded === true && props.completion.length > 0 ? (
        <>
          <Line
            ref={chartRef}
            options={options}
            plugins={chartpluginsset}
            data={{
              datasets: data.datasets || [],
              labels : data.labels || [],
            }}
          />
        </>
      ) : (
        <Box sx={{flex:1, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"15px"}}>
          <Box sx={{
            width:["50px", "60px", "60px", "75px"],
            minWidth:["50px", "60px", "60px", "75px"],
          }}>
            <img src={noCompletionChartIcon} style={{width:"100%"}}/>
          </Box>
          <Box sx={{
            color:"text.black",
            fontSize:["20px", "24px", "24px", "26px"],
            textAlign:"center",
          }}>
            {languageValues?.adminDashboard?.completionChart?.emptyTitle[actLanguage]}
          </Box>
          <Box sx={{
            color:"text.subTitle",
            fontSize:["15px", "16px", "16px", "17px"],
            textAlign:"center",
            maxWidth:"300px",
          }}>
            {languageValues?.adminDashboard?.completionChart?.emptySubTitle[actLanguage]}
          </Box>
        </Box>
      )}
    </>
  )
}


export default CompletionChart
